var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHamburgerDefault = function SvgHamburgerDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 89 89",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.043 25.752H3.906a2.67 2.67 0 0 1 0-5.342h81.137a2.67 2.67 0 1 1 0 5.342ZM85.043 47.577H3.906a2.67 2.67 0 1 1 0-5.342h81.137a2.67 2.67 0 1 1 0 5.342ZM85.043 69.403H3.906a2.67 2.67 0 0 1 0-5.342h81.137a2.67 2.67 0 0 1 0 5.342Z",
    fill: "currentColor"
  })));
};

export { SvgHamburgerDefault as ReactComponent };
export default __webpack_public_path__ + "2063f38f591d74daa32f0b8c97bcab2b.svg";